import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { get } from 'lodash';
import UpdateFeesModal from '../modals/UpdateFeesModal';

function FinalFeesInformation({ permitId, data, applicationInfo }) {

  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleUpdateFees = info => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateFeesModal feeData={info} permitId={permitId} />,
      title: 'Update Fee',
      modalSize: 'modal-md',
    });
  };

  const quarter = period => {
    if (period === 1) return '1 QTR';
    if (period === 2) return '2 QTR';
    if (period === 3) return '3 QTR';
    if (period === 4) return '4 QTR';
    return '';
  };

  return (
    <div className="p-3">
      <table className="transaction-table table table-bordered table-sm">
        <thead>
          <tr>
            <th>Description</th>
            <th className="text-center">Year</th>
            <th className="text-center">Period</th>
            <th className="text-center">Amount</th>
            {(Acl(permissions, ['UPDATE BPLS BILLING']) && get(applicationInfo, 'attributes.status') === 'COMPUTED') && (
              <th className="text-center">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map(item => {
            return (
              <tr key={item.id}>
                <td>
                  {get(item, 'attributes.code') || '-'} -{' '}
                  {get(item, 'attributes.description') || '-'}
                </td>
                <td className="text-center">
                  {get(item, 'attributes.year') || '-'}
                </td>
                <td className="text-center">
                  {get(item, 'attributes.qtr_from') || '-'}-
                  {quarter(get(item, 'attributes.qtr_to')) || ''}
                </td>
                <td className="text-right">
                  {get(item, 'attributes.amount_human') || '-'}
                </td>
                {(Acl(permissions, ['UPDATE BPLS BILLING']) && get(applicationInfo, 'attributes.status') === 'COMPUTED') && (
                  <td className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      <button
                        onClick={handleUpdateFees(item)}
                        type="button"
                        className="btn-blank btn-sm"
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

FinalFeesInformation.defaultProps = {
  permitId: '',
  applicationInfo: {},
}

FinalFeesInformation.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  permitId: PropTypes.string,
  applicationInfo: PropTypes.instanceOf(Object),
};

export default FinalFeesInformation;
